// extracted by mini-css-extract-plugin
export default {"home":"c-h_el","home__content":"c-h_em"};